//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapMutations } from "vuex";
export default {
  name: "ASRAAOL",
  data() {
    return {
      form: {
        age: "",
        nihss: "",
        f1: "",
        f2: "",
        f3: "",
        f4: "",
      },
      hasScore: false,
      disabled: false,
      dataList1: [
        { value: "0", name: "就诊时间<3小时" },
        { value: "2", name: "就诊时间≥3小时" },
      ],
      dataList2: [
        { value: "0", name: "无视野范围缺" },
        { value: "2", name: "出现由新的脑卒中引起的任何程度的视野范围的缺损" },
      ],
      dataList3: [
        { value: "0", name: "否" },
        { value: "1", name: "是" },
      ],
      dataList4: [
        { value: "0", name: "无意识水平障碍" },
        { value: "3", name: "有意识水平障碍" },
      ],
    };
  },
  created() {
    this.hideLoad();
  },
  methods: {
    ...mapMutations(["hideLoad"]),
  },
  computed: {
    /** 计算公式结果 */
    score() {
      let self = this;
      let form = JSON.parse(JSON.stringify(self.form));
      let flag = true;
      let result = 0;
      for (const key in form) {
        if (form.hasOwnProperty(key)) {
          if (!form[key]) {
            flag = false;
          } else {
            form[key] = Number(form[key]);
          }
        }
        if (key == "age") {
          result = result + Math.floor(form.age / 5);
        } else {
          result += Number(form[key]);
        }
      }
      console.log(result);
      if (!flag) {
        self.hasScore = false;
        return "";
      } else {
        self.hasScore = true;
        return String(result);
      }
    },
  },
};



// WEBPACK FOOTER //
// ./src/pages/formulas/Neuro/ASRAAOL.vue